
import Vue from 'vue'
import {
  VExpansionPanel,
  VExpansionPanelContent,
  VExpansionPanelHeader,
  VExpansionPanels,
} from 'vuetify/lib'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'

export default Vue.extend({
  name: 'JcdcExpansionPanel',
  components: {
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    JcdcBtn,
  },
  props: {
    items: {
      type: Array as () => Array<string>,
      default: (): [] => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panel: [] as number[],
      expandAll: false,
      expandText: 'Expand',
      rotateClass: '',
    }
  },
  methods: {
    expand() {
      this.expandAll = !this.expandAll
      this.$emit('click', this.expandAll)
      if (this.expandAll) {
        this.expandText = 'Collapse'
        this.rotateClass = 'v-icon-rotate'
        this.panel = [...Array(this.items.length).keys()].map((k, i) => i)
      } else {
        this.expandText = 'Expand'
        this.rotateClass = ''
        this.panel = []
      }
    },
  },
})
